/**
 * @generated SignedSource<<8633ab51539eb5964d048f1e02614494>>
 * @relayHash 2b9999c9f430b4dda72109599e853618
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 778533cd42b1035109f3872065d291e4f0d98dadaae1304d1ee064df84405593

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraUpdateTimeTrackingFieldInput = {
  id: string;
  originalEstimate?: JiraEstimateInput | null | undefined;
  remainingEstimate?: JiraEstimateInput | null | undefined;
};
export type JiraEstimateInput = {
  timeInSeconds: AGG$Long;
};
export type originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation$variables = {
  input: JiraUpdateTimeTrackingFieldInput;
};
export type originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation$data = {
  readonly jira: {
    readonly updateTimeTrackingField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly originalEstimate: {
          readonly timeInSeconds: AGG$Long | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation$rawResponse = {
  readonly jira: {
    readonly updateTimeTrackingField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly originalEstimate: {
          readonly timeInSeconds: AGG$Long | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation = {
  rawResponse: originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation$rawResponse;
  response: originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation$data;
  variables: originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraTimeTrackingFieldPayload",
        "kind": "LinkedField",
        "name": "updateTimeTrackingField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraTimeTrackingField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "778533cd42b1035109f3872065d291e4f0d98dadaae1304d1ee064df84405593",
    "metadata": {},
    "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8e4396c085a50b830136e492ba97931f";

export default node;
